import { getFromLocalStorage } from '@/local-storage/utils';
import { PropsWithChildren, createContext, useState } from 'react';

export type ThemeContextType = {
  theme: 'light' | 'dark';
  setTheme: React.Dispatch<React.SetStateAction<'light' | 'dark'>>;
};

export const ThemeContext = createContext<ThemeContextType>({
  theme: 'light',
  // @ts-expect-error todo: fix type
  setTheme: undefined,
});

const getDefaultTheme = (): 'light' | 'dark' => {
  const theme = getFromLocalStorage('theme');
  if (theme) {
    if (theme == 'dark') {
      // ensure 'dark' class is added to body
      document.body.classList.add('dark');
      document.body.classList.remove('light');
    } else {
      // ensure 'light' class is added to body
      document.body.classList.add('light');
      document.body.classList.remove('dark');
    }
    return theme as 'light' | 'dark';
  }

  return 'light';
};

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  const [theme, setTheme] = useState<'light' | 'dark'>(getDefaultTheme());

  return (
    <ThemeContext.Provider
      value={{
        theme,
        setTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
